import React from 'react';
import FeedbackIcon from '../../assets/images/feedback-icon.svg';
import { InputTextAreaComponent } from './InputTextArea';
import { RatingIcons, SubmittedFeedbackSuccess } from './FeedbackComponents';
import Button from "../Form/Button/Button";
import { Component } from 'react';

/** @import {FeedbackProps, FeedbackState, SubmitFeedback} from './FeedbackTypes' */

/** @extends {Component<FeedbackProps, FeedbackState>} */
export class Feedback extends Component {
    /** @type {FeedbackState} */
    state = {
        isActive: false,
        isSubmitted: false
    };

    toggleActive = () => this.setState((prevState) => ({ isActive: !prevState.isActive, isSubmitted: false }));

    handleSubmitFeedback = (/** @type {string} */ rating, /** @type {string} */ comments) => {
        this.props.submitFeedback(rating, comments);
        this.setState(() => ({ isSubmitted: true }));
    };

    render() {
        const { isActive, isSubmitted } = this.state;

        const iconInterim = (
            <div>
                <FeedbackIcon></FeedbackIcon>
            </div>
        );

        return (
            <>
                {this.props.enabled && <div className={'feedback-container'}>
                    <Button 
                        label={'Give feedback'} 
                        onClick={this.toggleActive} 
                        leftIcon={iconInterim}/>
                    <div className={'feedback-submit'}>
                        {isActive && !isSubmitted ? (
                            <UnSubmittedFeedBack submitFeedback={this.handleSubmitFeedback} themeName={this.props.themeName}/>
                        ) : isSubmitted ? (
                            <SubmittedFeedback/>
                        ) : null}
                    </div>
                </div>}
            </>
        );
    }
}

function UnSubmittedFeedBack(/** @type {{ submitFeedback: SubmitFeedback; themeName: string; }} */ { submitFeedback, themeName }) {
    const [rating, setRating] = React.useState('');
    const [comments, setComments] = React.useState('');
    const [borderColour, setColour] = React.useState('');

    const isSubmitDisabled = comments === '' && rating === '';
    const handleChangeRating = (/** @type {string} */ key, /** @type {string} */ borderColour) => {
        setRating(key);
        setColour(borderColour);
    };
    const handleChangeComments = (/** @type {React.ChangeEvent<HTMLTextAreaElement>} */ value) => {
        setComments(value.target.value)
    };

    const handleSubmit = (/** @type {React.FormEvent<HTMLFormElement>} */ event) => {
        event.preventDefault();

        if (!isSubmitDisabled) {
            submitFeedback(rating, comments);
            setRating('');
            setComments('');
        }
    };
    return (
        <form className={'feedback'} onSubmit={handleSubmit}>
            <RatingsSection
                selectedRating={rating}
                onRatingChanged={handleChangeRating}
                themeName={themeName}
            />
            <InputTextAreaComponent
                value={comments}
                onChange={handleChangeComments}
            />
            <div className={'actions'}>
                <Button disabled={isSubmitDisabled} data-testid="feedbackButton" type="submit" label={'Submit'}/>
            </div>
        </form>
    );
};

const RatingsSection = React.memo(
    (/** @type {{ selectedRating: string; themeName: string; onRatingChanged: (key: string, borderColour: string) => void }} */ {
        selectedRating,
        onRatingChanged,
        themeName
     }) => (
        <div className={'fieldset'}>
            <RatingIcons
                selectedRating={selectedRating}
                onRatingChanged={onRatingChanged}
                themeName={themeName}
            />
        </div>
    )
);

const SubmittedFeedback = () => (
    <div className={'feedback'} aria-live="assertive">
        <SubmittedFeedbackSuccess
            // @ts-expect-error this component does not have that prop
            successIconClassName={'success-icon'} successTitleClassName={'success-title'} 
        />
    </div>
);
